import { useRootData } from '@hooks/hook';
import { InterventionCommentType } from '@services/src/models';
import React, { useState } from 'react';

import { InterventionCommentDto } from './commands/InterventionCommentsCommand';
import { IInterventionCommentStore } from './store/InterventionCommentStore';

interface ICommentAreaProps {
	fieldName?: string;
	children: React.ReactElement;
}

export const InterventionCommentArea = (props: ICommentAreaProps) => {
	const interventionCommentStore: IInterventionCommentStore = useRootData(
		(store) => store.interventionCommentStore
	);

	const [state, setState] = useState<
		Record<string, InterventionCommentDto> | undefined
	>(interventionCommentStore.marks.get());

	interventionCommentStore.marks.observe(() => {
		const marks = interventionCommentStore.marks.get();

		if (marks) {
			setState(marks);
		}
	});

	const getAreaClassByCommentType = () => {
		if (state && props.fieldName) {
			const comment: InterventionCommentDto | undefined = state![
				props.fieldName
			];

			if (comment?.body) {
				if (comment.type === InterventionCommentType.IMPORTANT) {
					return 'comment-area important';
				}

				return 'comment-area info';
			}
		}
		return '';
	};

	return <div className={getAreaClassByCommentType()}>{props.children}</div>;
};
